"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var _user = require("@/api/user");
var _training = require("@/api/training");
var _cookie = require("@/utils/cookie");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CountTo: _vueCountTo.default
  },
  data() {
    return {
      totalNoOfUser: -1,
      totalNoOfUnconfirmUser: -1,
      totalNoOfILT: -1
    };
  },
  created() {
    this.getNoOfUsersFigure('CONFIRMED');
    this.getNoOfUsersFigure('UNCONFIRMED');
    this.getNoOfILTEventsFigure();
  },
  methods: {
    handleSetLineChartData(type) {
      this.$emit('handleSetLineChartData', type);
    },
    getNoOfUsersFigure(s) {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var query = {
        status: s
      };
      (0, _user.getNoOfUsers)(token, query).then(response => {
        if (s === 'CONFIRMED') {
          this.totalNoOfUser = response.data.count ? response.data.count : 0;
        } else {
          this.totalNoOfUnconfirmUser = response.data.count ? response.data.count : 0;
        }
      });
    },
    getNoOfILTEventsFigure() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      var query = {
        page: 1,
        limit: 1,
        sort: '-createdAt',
        publish: 'published'
      };
      (0, _training.getTrainingList)(token, query).then(response => {
        this.totalNoOfILT = response.data.count ? response.data.count : 0;
      });
    }
  }
};